module.exports = __webpack_public_path__ + "static/media/1.3cc091f9.jpg";